<template>
  <div>
    <div v-if="extra.old">
      <span class="timeline-key">Amount </span> : {{ cost }} <br>
      <span class="timeline-key">Invoice number </span> : {{ extra.invoice_number }} <br>
    </div>

    <div v-else>
      <span v-if="extra.source && extra.source.toLowerCase() === 'online'">
        <span class="timeline-key">Source </span>: Online Card Payment
        <br>
        <span class="timeline-key">Amount </span> :
        {{ extra.transaction_detail.amount }} USD
        <br>
        <span class="timeline-key">Trasaction ID: </span> :
        {{ extra.transaction_detail.ipay_out__ipg_txn_id }}
        <br>
        <span class="timeline-key">Merchant Reference ID: </span> :
        {{ extra.transaction_detail.ipay_out__mer_ref_id }}
        <br>
      </span>

      <span v-else>
        <span class="timeline-key">Source </span> :
        <b>{{ extra.source }}</b>
        <br>
<!--        <div v-if="extra.voucher_detail">-->
<!--          <span class="timeline-key">Voucher Number </span>:-->
<!--          {{ extra.voucher_detail.data.code ? extra.voucher_detail.data.code : extra.voucher_detail.data.ebpNo }}-->
<!--        </div>-->
        <div v-if="extra.voucher_detail">
          <span class="timeline-key">Voucher Number </span>:
          {{ extra.voucher_detail.code ? extra.voucher_detail.code : extra.voucher_detail.ebpNo }}
        </div>
        <span class="timeline-key">Amount ($)</span> : {{ cost ? cost : extra.cost }}  <br>
        <span class="timeline-key">Amount (NPR) </span> : {{ cost_npr ? cost_npr : '' }}<br>

        <span v-if="extra.manual">
            <span class="timeline-key">Bank </span> : {{ extra.bank }} <br>
            <span class="timeline-key">Invoice number : </span> {{ extra.invoice_number }} <br>
            <div v-if="extra.late_stay_cost>0">
              <span class="timeline-key">Late stay cost : </span>
              {{ extra.late_stay_cost }} USD
            </div>
            <div v-if="extra.penalty>0">
              <span class="timeline-key" v-if="extra.penalty_cost>0">Penalty : </span>
              {{ extra.penalty_cost }} USD
            </div>
            <div v-if="extra.penalty_npr>0">
              <span class="timeline-key" v-if="extra.penalty_npr>0">Penalty (NPR) : </span>
              {{ extra.penalty_npr }}
            </div>
            <div v-if="extra.desk_code">
              <span class="timeline-key">Desk Code </span>:
              {{ extra.desk_code }}
            </div>
        </span>
        <span v-else>
            <span v-if="trekking">
              <span class="timeline-key">Amount(NPR) </span> :
              {{ item.voucher_detail.totalAmount ? item.voucher_detail.totalAmount : item.voucher_detail.amount }}
              <br>
              <div v-if="item.voucher_detail.collectedBank">
                <span class="timeline-key">Bank </span> :
                {{ item.voucher_detail.collectedBank.bankEDesc }}
              </div>
              <div v-if="item.voucher_detail.userDefined1">
                <span class="timeline-key">Office </span> :
                {{ item.voucher_detail.userDefined1 }}
              </div>
            </span>
            <span v-else>
              <span class="timeline-key">Amount(NPR) </span> :
              {{ extra && extra.amount_npr ? extra.amount_npr : extra.voucher_detail.data.amount }}
              <div v-if="extra.voucher_detail.data.collectedBank">
                <span class="timeline-key">Bank </span> :
                {{ extra.voucher_detail.data.collectedBank.bankEDesc }}
              </div>
              <div v-if="extra.late_stay_cost>0">
                <span class="timeline-key">Late stay cost : </span>
                {{ extra.late_stay_cost }} USD
              </div>
              <div v-if="extra.penalty_cost>0">
                <span class="timeline-key">Penalty :</span>
                {{ extra.penalty_cost }} USD
              </div>
            </span>
        </span>

        <file-display :src="extra.image" v-if="extra.image"/>
      </span>

      <v-layout row wrap v-if="extra.attachments">
        <v-flex xs4 v-for="attachment in extra.attachments">
          <file-display :src="attachment"/>
        </v-flex>
      </v-layout>

    </div>
  </div>
</template>

<script>
import FileDisplay from "../../FileDisplay";

export default {
  name: "Paid",
  components: {FileDisplay},
  props: ['item', 'extra', 'days', 'cost', 'cost_npr', 'user', 'trekking'],
}
</script>
